import styled from 'styled-components';

export const SearchForm = styled.form``;

export const SortList = styled.div`
  display: flex;
  margin-top: 15px;
`;
